export enum UserType {
    COMPANY = 'company',
    PHOTOGRAPHER = 'photographer'
}